export const SCHEMA_AGENT_INTRO_KEY = 'spectre:schema-agent:intro:v1'

let shownInThisTab = false

/** Claim the first visit across cases, with a tab fallback when storage is blocked. */
export function claimSchemaAgentIntro(): boolean {
  if (typeof window === 'undefined' || shownInThisTab) return false
  try {
    if (window.localStorage.getItem(SCHEMA_AGENT_INTRO_KEY)) return false
    window.localStorage.setItem(SCHEMA_AGENT_INTRO_KEY, 'seen')
  } catch {
    // The introduction should never stop navigation in restricted browsers.
  }
  shownInThisTab = true
  return true
}
